import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CalendarDays, Check } from "lucide-react";
import { type PricingPlan } from "@/utils/pricing";

interface PricingTabsProps {
  plans: PricingPlan[];
  selectedPlan: PricingPlan | null;
  onSelectPlan: (plan: PricingPlan) => void;
  onPlanSelect?: (plan: PricingPlan) => void;
  className?: string;
  showActionButton?: boolean;
}

export const PricingTabs = ({
  plans,
  selectedPlan,
  onSelectPlan,
  onPlanSelect,
  className = "",
  showActionButton = true
}: PricingTabsProps) => {

  return (
    <Tabs
      // KRİTİK: 'defaultValue' yerine 'value' kullanıyoruz. 
      // Bu, 2999 TL takılı kalma sorununu çözen ana değişiklik.
      value={selectedPlan?.id || "monthly"}
      className={`w-full ${className}`}
      onValueChange={(value) => {
        const plan = plans.find(p => p.id === value);
        if (plan) {
          onSelectPlan(plan);
        }
      }}
    >
      {/* Orijinal Liste Tasarımı */}
      <TabsList className="grid w-full grid-cols-3 mb-4">
        {plans.map((plan) => (
          <TabsTrigger
            key={plan.id}
            value={plan.id}
            className="text-sm truncate px-2"
          >
            {plan.name}
          </TabsTrigger>
        ))}
      </TabsList>

      {plans.map((plan) => (
        <TabsContent key={plan.id} value={plan.id}>
          {/* Orijinal Beyaz Kart Tasarımı */}
          <Card className="border shadow-sm bg-white">
            <CardContent className="p-6">
              <div className="space-y-4">
                <div className="flex items-baseline justify-between">
                  <span className="text-3xl font-bold text-slate-900">
                    {plan.pricePerMonth}₺
                    <span className="text-sm font-normal text-muted-foreground ml-1">
                      /ay
                    </span>
                  </span>
                  {plan.discount > 0 && (
                    <span className="text-sm font-semibold text-green-600 bg-green-50 px-2 py-1 rounded">
                      %{plan.discount} indirim
                    </span>
                  )}
                </div>

                <div className="space-y-2 border-t pt-4">
                  <div className="flex items-center gap-2 text-slate-600">
                    <CalendarDays className="h-4 w-4" />
                    <span className="text-sm">
                      {plan.months} Ay kullanım süresi
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-900 font-semibold">
                    <Check className="h-4 w-4 text-green-600" />
                    <span className="text-sm">
                      Toplam Ödeme: {plan.totalPrice}₺
                    </span>
                  </div>
                </div>
              </div>

              {showActionButton && onPlanSelect && (
                <Button
                  className="w-full mt-4 bg-brand-primary hover:bg-brand-primary/90 text-white"
                  onClick={() => onPlanSelect(plan)}
                >
                  Bu Planı Seç
                </Button>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      ))}
    </Tabs>
  );
};